import FullScreenBanner from '@/components/full-screen-banner'
import banner from '@/assets/img/solution/school-bus/banner.jpg'
import Styles from './style.module.scss'

const TITLE = 'Carus School Bus Replacement\nwith Charging Facility\nZero-Emission Future for\nSafer Schools'

export default function Banner() {
  return (
    <FullScreenBanner image={banner} className={Styles.banner} vertical>
      <h2>{TITLE}</h2>
    </FullScreenBanner>
  )
}
